// src/utils/htmlHelpers.js

/**
 * Extracts body content from full HTML
 */
export const extractBody = (html = "") => {
    if (!html) return "";
  
    const match = html.match(/<body[^>]*>([\s\S]*?)<\/body>/i);
    return match ? match[1] : html;
  };
  
  /**
   * Wrap edited body back into original HTML structure
   */
  export const wrapHTML = (bodyContent, originalHTML = "") => {
    if (!originalHTML) {
      return `
        <html>
          <head></head>
          <body>${bodyContent}</body>
        </html>
      `;
    }
  
    const headMatch = originalHTML.match(/<head[^>]*>[\s\S]*?<\/head>/i);
    const head = headMatch ? headMatch[0] : "<head></head>";
  
    return `
      <html>
        ${head}
        <body>${bodyContent}</body>
      </html>
    `;
  };
  